import { FEDERAL_COURT_GROUPS } from '@/jurisdiction-mappings/legal-research-sources.generated'

export type FederalCheckboxOption = {
  id: string
  label: string
  value: {
    federalCourtJurisdictionCodes: string[]
  }
}

export type FederalCourtChildOption = {
  label: string
  codes: string[]
}

export type FederalCheckboxOptionWithChildren = FederalCheckboxOption & {
  children: FederalCourtChildOption[]
  primaryJurisdictionCodes: string[]
}

const topLevelGroup = FEDERAL_COURT_GROUPS.find((group) => group.isTopLevel)!

export const TOP_LEVEL_FEDERAL_COURTS: FederalCheckboxOption[] = topLevelGroup.courts.map((court) => ({
  id: court.label,
  label: court.label,
  value: { federalCourtJurisdictionCodes: court.codes },
}))

export const CIRCUIT_BASED_FEDERAL_COURTS: FederalCheckboxOptionWithChildren[] = FEDERAL_COURT_GROUPS.filter((group) => !group.isTopLevel).map((group) => ({
  id: group.label,
  label: group.label,
  value: {
    federalCourtJurisdictionCodes: group.courts.flatMap((court) => court.codes),
  },
  children: group.courts.map((court) => ({
    label: court.label,
    codes: court.codes,
  })),
  primaryJurisdictionCodes: group.primaryCodes ?? [],
}))
